export { default } from './MoneyBagDiamond'
